var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 17,
    viewBox: "0 0 8 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45703 16.5264V9.32637H7.64294L8 6.12637H5.45703V4.56777C5.45703 3.74377 5.47808 2.92637 6.62952 2.92637H7.79575V0.638477C7.79575 0.604077 6.79399 0.526367 5.78054 0.526367C3.664 0.526367 2.33872 1.85212 2.33872 4.28652V6.12637H0V9.32637H2.33872V16.5264H5.45703Z",
    fill: "#f4f4f4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.92330daf70dcd9f24fc67f354761dee9.svg";
export { ForwardRef as ReactComponent };